export function parseIntegerSetting(value: string | undefined | null, fallback: number): number {
  const n = Number.parseInt(String(value ?? '').trim(), 10);
  return Number.isFinite(n) ? n : fallback;
}

export function parsePercentSetting(value: string | undefined | null, fallback: number): number {
  return parseIntegerSetting(value, fallback);
}

export function parseDecimalSetting(value: string | undefined | null, fallback: number): number {
  const n = Number.parseFloat(String(value ?? '').trim());
  return Number.isFinite(n) ? n : fallback;
}

export function parseUsdSetting(value: string | undefined | null, fallback: number): number {
  return parseIntegerSetting(value, fallback);
}
